import React, {Component} from 'react';
import {BigButtonTool} from "../../../toolsSpace/oneLineToolSpace";
import securityIcon from "./security.png";
import SecurityCheck from "../../../floatTool/securityCheck";

class SecurityPlugin extends Component {

    listenContentChange(){
        this.securityCheck.listenContentChange();
    }

    render() {
        return (
            <div>
                <BigButtonTool float={this.props.float} style={this.props.style}
                               onClick={()=>this.securityCheck.asyncCheck({noDataShowInfo:true})}
                               src={securityIcon} text={"安全检测"} imgWidth={this.props.width} />
                <SecurityCheck ref={securityCheck=>{
                    this.securityCheck = securityCheck;
                    this.props.editor.securityCheckAsyncCheck = (checkAfterContinueExecFun)=>this.securityCheck.asyncCheck({checkAfterContinueExecFun});
                }} dynamicParams={this.props.dynamicParams} editor={this.props.editor}  />
            </div>
        );
    }
}

export default SecurityPlugin;